import { SidebarIcon } from '@braskai/icons';
import { useDeviceType } from '@braskai/ui-kit';

import { SSidebarButton } from './styled';

type SidebarButtonProps = {
  locked?: boolean;
  onClick?: () => void;
};

export const SidebarButton = ({ locked, onClick }: SidebarButtonProps) => {
  const { isDesktop, isLaptop } = useDeviceType();

  if (!(isLaptop || isDesktop)) {
    return null;
  }

  return (
    <SSidebarButton
      title={locked ? 'Hide sidebar' : 'Lock sidebar'}
      $locked={locked}
      startIcon={<SidebarIcon height={16} width={16} />}
      variant="text"
      onClick={onClick}
    />
  );
};
